export const AmdButtonType = {
  ICON_BUTTON: "ICON_BUTTON",
  PRIMARY: "PRIMARY",
  DEFAULT: "DEFAULT",
  CHIP: "CHIP",
  PILL: "PILL",
  DASHED: "DASHED",
};
